import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.99999 7.20039C8.63651 7.20039 9.24696 6.94753 9.69705 6.49745C10.1471 6.04736 10.4 5.43691 10.4 4.80039C10.4 4.16387 10.1471 3.55342 9.69705 3.10333C9.24696 2.65325 8.63651 2.40039 7.99999 2.40039C7.36347 2.40039 6.75303 2.65325 6.30294 3.10333C5.85285 3.55342 5.59999 4.16387 5.59999 4.80039C5.59999 5.43691 5.85285 6.04736 6.30294 6.49745C6.75303 6.94753 7.36347 7.20039 7.99999 7.20039ZM2.39999 14.4004C2.39999 13.665 2.54484 12.9368 2.82627 12.2574C3.10769 11.5779 3.52019 10.9606 4.0402 10.4406C4.5602 9.92059 5.17754 9.50809 5.85697 9.22667C6.53639 8.94524 7.26459 8.80039 7.99999 8.80039C8.7354 8.80039 9.4636 8.94524 10.143 9.22667C10.8224 9.50809 11.4398 9.92059 11.9598 10.4406C12.4798 10.9606 12.8923 11.5779 13.1737 12.2574C13.4551 12.9368 13.6 13.665 13.6 14.4004H2.39999Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}